<dxp-multi-selector [selectorId]="this.componentId" data-source-key-name="description" [items]="this.employeeList"
    search-placeholder="{{msg.PlaceHolders.SelectOptions}}" placeholder="{{msg.PlaceHolders.SelectOptions}}"
    [label]="this.displayLabel" [optional]="this.isOptional" (selectedOptions)="setSelectedEmployee($event)"
    multi-search="true" [maxLimit]="this.maxSelectionCount" [list-aria-label]="this.ariaText" #idEmployeeReference>
</dxp-multi-selector>
<span class="form-validation-error"
    *ngIf="!this.isOptional && this.submitted === 'enabled' && selectorControlName.touched && selectorControlName.errors && selectorControlName.errors['required']">
    {{msg.FormValidationMessage.EmployeeNameRequired}}
</span>